<template>
	<div class="flex flex-row mt-2 items-center">
		<app-select
			class="limit-select"
			mode="single"
			:canDeselect="false"
			:options="perPageOptions"
			:model-value="filters.limit"
			@select="$emit('limitChange', $event)"
		/>
		<app-button
			class="btn btn-primary transparent mr-2 small z-0"
			:disabled="filters.offset == 0"
			@click="filters.offset != 0 && $emit('prevPage')"
			icon="left"
			:loading="loading"
		/>
		<app-button
			class="btn btn-primary transparent mr-2 small z-0"
			@click="hasNextPage && $emit('nextPage')"
			icon="right"
			:loading="loading"
			:disabled="!hasNextPage"
		/>
		<div v-if="length" class="flex gap-2">
			<span
				v-if="isInteger"
				class="text-13 text-info hover:underline cursor-pointer"
				@click="hasNextPage && $emit('loadMore')"
				>Load more...</span
			>
			<span v-if="length" class="text-13 text-muted">{{ length }} items</span>
		</div>
	</div>
</template>

<script>
	import AppSelect from '@/components/app/AppSelect';

	export default {
		name: 'AppPagination',
		components: { AppSelect },
		emits: ['prevPage', 'nextPage', 'limitChange', 'loadMore'],
		props: {
			filters: {
				type: Object,
				required: true,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			hasNextPage: {
				type: Boolean,
				default: true,
			},
			length: {
				type: Number,
				default: 0,
			},
		},
		data: () => ({
			perPageOptions: [
				{ value: 5, label: 5 },
				{ value: 10, label: 10 },
				{ value: 25, label: 25 },
				{ value: 50, label: 50 },
				{ value: 100, label: 100 },
			],
		}),
		computed: {
			isInteger() {
				return Number.isInteger(this.length / this.filters.limit);
			},
		},
	};
</script>

<style lang="scss" scoped>
	:deep(.limit-select) {
		@apply w-20 mr-2;
		.multiselect-input {
			@apply h-9 border-primary;
		}
		.multiselect-options {
			@apply -mt-56 h-48;
			max-height: 500px !important;
		}
	}
</style>
